import React, { useEffect, useState } from 'react';
export const Footer = () => {
  const [showStickyFooter, setShowStickyFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Get the benefits section element
      const benefitsSection = document.getElementById('benefits');
      if (benefitsSection) {
        // Get the position of the benefits section
        const benefitsSectionPosition = benefitsSection.getBoundingClientRect().top;
        // Show the sticky footer if the user has scrolled past the benefits section
        // (when the top of the benefits section is above the viewport)
        setShowStickyFooter(benefitsSectionPosition < 0);
      }
    };
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    // Clean up event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <footer data-id="element-286">
      <div className="w-full bg-gray-100 py-12 px-4" data-id="element-287">
        <div className="max-w-5xl mx-auto" data-id="element-288">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-289">
            <div data-id="element-290">
              <h3 className="font-semibold text-lg mb-4 text-gray-800" data-id="element-291">
                About Ardava
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-292">
                Ardava creates innovative, comfortable compression products
                designed to support your active lifestyle without compromise.
              </p>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ktds4aRCZkYDJdageQMuRp/ardava_logo.webp" alt="Ardava Logo" className="h-8" data-id="element-293" />
            </div>
            <div data-id="element-294">
              <h3 className="font-semibold text-lg mb-4 text-gray-800" data-id="element-295">
                Quick Links
              </h3>
              <ul className="space-y-2" data-id="element-296">
                <li data-id="element-297">
                  <a href="#features" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-298">
                    Features
                  </a>
                </li>
                <li data-id="element-299">
                  <a href="#benefits" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-300">
                    Benefits
                  </a>
                </li>
                <li data-id="element-301">
                  <a href="#reviews" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-302">
                    Reviews
                  </a>
                </li>
                <li data-id="element-303">
                  <a href="#faq" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-304">
                    FAQ
                  </a>
                </li>
                <li data-id="element-305">
                  <a href="#legal" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-306">
                    Legal
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-307">
              <h3 className="font-semibold text-lg mb-4 text-gray-800" data-id="element-308">
                Customer Support
              </h3>
              <ul className="space-y-2" data-id="element-309">
                <li data-id="element-310">
                  <a href="mailto:support@ardava.store" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-311">
                    Contact Us
                  </a>
                </li>
                <li data-id="element-312">
                  <a href="#" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-313">
                    Shipping Policy
                  </a>
                </li>
                <li data-id="element-314">
                  <a href="#" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-315">
                    Return Policy
                  </a>
                </li>
                <li data-id="element-316">
                  <a href="#" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-317">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-318">
                  <a href="#" className="text-gray-600 hover:text-teal-700 transition-colors" data-id="element-319">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* Trust Badge Section */}
          <div className="border-t border-gray-300 pt-8 pb-6 mb-6" data-id="element-320">
            <div className="text-center mb-6" data-id="element-321">
              <h4 className="font-semibold text-lg mb-4 text-gray-800" data-id="element-322">
                Trusted & Secure
              </h4>
              <div className="flex flex-wrap justify-center items-center gap-6 mb-6" data-id="element-323">
                {/* Credit Card Badge */}
                <div className="bg-white px-4 py-2 rounded-md shadow-sm" data-id="element-324">
                  <a href="https://trustlock.co" className="inline-block" data-id="element-325">
                    <img src="https://trustlock.co/wp-content/uploads/2019/01/old-credit-card-logo-icons-free.png" alt="Trust Badges" width="139" height="65" className="border-0" data-id="element-326" />
                  </a>
                </div>
                {/* SSL Secure Checkout Badge */}
                <div className="bg-white px-4 py-2 rounded-md shadow-sm" data-id="element-327">
                  <a href="https://trustlock.co" className="inline-block" data-id="element-328">
                    <img src="https://trustlock.co/wp-content/uploads/2019/01/ssl-secure-trust-badge-free.png" alt="SSL Secure Checkout" width="171" height="75" className="border-0" data-id="element-329" />
                  </a>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-330">
              <div className="flex flex-wrap justify-center items-center gap-6 mb-4" data-id="element-331">
                <div className="bg-white px-4 py-2 rounded-md shadow-sm flex items-center" data-id="element-332">
                  <svg className="w-6 h-6 text-teal-600 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-333">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-334"></path>
                  </svg>
                  <span className="font-medium text-gray-700" data-id="element-335">
                    60-Day Guarantee
                  </span>
                </div>
                <div className="bg-white px-4 py-2 rounded-md shadow-sm flex items-center" data-id="element-336">
                  <svg className="w-6 h-6 text-teal-600 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-337">
                    <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" data-id="element-338"></path>
                    <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2v5a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H19a1 1 0 001-1V9a1 1 0 00-.293-.707L16.414 5H13V4a1 1 0 00-1-1H3z" data-id="element-339"></path>
                  </svg>
                  <span className="font-medium text-gray-700" data-id="element-340">
                    Free Shipping on Pairs
                  </span>
                </div>
                <div className="bg-white px-4 py-2 rounded-md shadow-sm flex items-center" data-id="element-341">
                  <svg className="w-6 h-6 text-teal-600 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-342">
                    <path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" data-id="element-343"></path>
                  </svg>
                  <span className="font-medium text-gray-700" data-id="element-344">
                    Secure Checkout
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-300 pt-6 text-center" data-id="element-345">
            <p className="text-gray-600 text-sm mb-4" data-id="element-346">
              © {new Date().getFullYear()} Ardava. All Rights Reserved.
            </p>
            <p className="text-gray-600 text-sm mb-4" data-id="element-347">
              Contact us:{' '}
              <a href="mailto:support@ardava.store" className="text-teal-600 hover:text-teal-700" data-id="element-348">
                support@ardava.store
              </a>
            </p>
            <div className="flex justify-center space-x-4" data-id="element-349">
              <a href="#" className="text-gray-500 hover:text-teal-700" data-id="element-350">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-351">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" data-id="element-352" />
                </svg>
              </a>
              <a href="#" className="text-gray-500 hover:text-teal-700" data-id="element-353">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-354">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" data-id="element-355" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Sticky Footer - Only show after scrolling past benefits section */}
      {showStickyFooter && <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-3 px-4 shadow-md" data-id="element-356">
          <div className="max-w-5xl mx-auto flex justify-between items-center" data-id="element-357">
            <div className="flex-1" data-id="element-358">
              <p className="font-medium text-teal-700" data-id="element-359">
                Lock In Intro Pricing Now
              </p>
              <p className="text-xs text-gray-500" data-id="element-360">
                Ships Friday · Price locks at checkout · 60-Day Guarantee
              </p>
            </div>
            <div className="flex items-center" data-id="element-361">
              <div className="text-right mr-4 hidden sm:block" data-id="element-362">
                <p className="text-xs text-gray-600" data-id="element-363">
                  $64.99 (pair) · $39.99 (single)
                </p>
                <p className="text-xs text-gray-600" data-id="element-364">
                  Free first size exchange
                </p>
              </div>
              <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" data-id="element-365">
                <button className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors" data-id="element-366">
                  Find Your Size & Get a Pair →
                </button>
              </a>
            </div>
          </div>
        </div>}
    </footer>;
};